import {QesIcon} from "@app/shared/icons/QESIcon";
import {QesIcons} from "@app/shared/icons/qesIcons";
import {FC, useContext} from "react";
import { CountyProjectContext } from "@app/projects/CountyProjectContext";
import { ProviderHubBasicFilters } from "@app/projects/network-assessment/provider-hub/ProvidersHubBasicFilters";
import ProviderActionsDrawerFlyout from "../provider-actions/ProviderActionsDrawerFlyout";

export const ProviderHubEmptyState: FC = () => {
  const projectContext = useContext(CountyProjectContext);

  return (
    <>
    
      <ProviderHubBasicFilters />

      <div className="welcome-message">
        <QesIcon
          color="#036242"
          iconName={QesIcons.List}
          style={{
            backgroundColor: '#CCF5E7',
            borderRadius: '50%',
            height: '50px',
            padding: '10px',
            width: '50px'
          }}
          isDecorative
        />
        <h2 className="welcome-subtitle">Welcome to the Provider Hub</h2>
        <p className="welcome-description">Use the search bar or add filters to find individuals or list of providers in your project</p>

        <div className="welcome-process">
          <ProviderActionsDrawerFlyout
            classNames="ml10 qes-button-secondary provider-actions-link"
            disabled={projectContext.project.isReadOnly}
            testId="provider-hub-empty-state__provider-actions-flyout-link">
            Provider Action Management
          </ProviderActionsDrawerFlyout>
          <span>to view or process any unprocessed providers for the project</span>
        </div>
      </div>
    </>
  );
}